import {
  Button,
  useTheme
} from '@mui/material';
import { useAccessState } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import {
  CreateDocumentsModal,
  SaveFolderModal
} from 'modules/components/layer17';
import { ActivityHeaderSectionWithSearchLayout } from 'modules/components/layer32';
import { useState } from 'react';



export type FilesHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: FilesHeaderSectionProps) => {

  return (
    <ActivityHeaderSectionWithSearchLayout.FC
      title='Files'
      subtitle=''
      actionButtons={<ActionButtonsGroup />}
      searchBar={<></>}
    />
  );
};

type ActionButtonsGroup = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isUploadDocumentVisible,
    setIsUploadDocumentVisible
  ] = useState(false);

  const folderAccess = useAccessState('Folder');
  const documentAccess = useAccessState('Document');

  return (
    <>
      {isVisible && (
        <SaveFolderModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      {isUploadDocumentVisible && (
        <CreateDocumentsModal.FC
          id=''
          isVisible={isUploadDocumentVisible}
          handleClose={() => setIsUploadDocumentVisible(() => false)}
        />
      )}
      <Button
        variant='outlined'
        color='primary'
        onClick={() => setIsVisible(() => true)}
        disabled={!folderAccess.create}
        startIcon={(
          <CustomIcon.large.FC
            icon='PLUS'
            stroke={theme.palette.primary.main}
          />
        )}
      >
        Create new folder
      </Button>

      <Button
        variant='contained'
        color='primary'
        onClick={() => setIsUploadDocumentVisible(() => true)}
        disabled={!documentAccess.create}
        startIcon={(
          <CustomIcon.large.FC
            icon='UPLOAD'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Upload Files
      </Button>

    </>
  );
};
